/**
 * Limits for saved homes by subscription tier
 */
export const SAVED_HOME_LIMITS = {
  FREE: 2,
  PRO: 10,
  AGENT: 10
};

/**
 * Limits for monthly walkthroughs by subscription tier
 */
export const MONTHLY_WALKTHROUGH_LIMITS = {
  FREE: 3,
  PRO: 30,
  AGENT: 30
};

/**
 * Activity types for activity log
 */
export const ACTIVITY_TYPES = {
  // Client activities
  CLIENT_ADDED: 1,
  CLIENT_REMOVED: 2,
  CLIENT_UPDATED: 3,
  
  // Agent activities
  AGENT_JOINED: 10,
  AGENT_REMOVED: 11,
  AGENT_UPDATED: 12,
  
  // Home activities
  HOME_ADDED: 20,
  HOME_REMOVED: 21,
  HOME_VIEWED: 22,
  
  // Walkthrough activities
  WALKTHROUGH_SCHEDULED: 30,
  WALKTHROUGH_COMPLETED: 31,
  
  // Communication activities
  MESSAGE_SENT: 40,
  MESSAGE_RECEIVED: 41,
  
  // Business activities
  BUSINESS_UPDATED: 50,
  
  // Other
  OTHER: 999
} as const;

/**
 * Activity type labels for display
 */
export const ACTIVITY_TYPE_LABELS: Record<number, string> = {
  [ACTIVITY_TYPES.CLIENT_ADDED]: 'Client Added',
  [ACTIVITY_TYPES.CLIENT_REMOVED]: 'Client Removed',
  [ACTIVITY_TYPES.CLIENT_UPDATED]: 'Client Updated',
  [ACTIVITY_TYPES.AGENT_JOINED]: 'Agent Joined',
  [ACTIVITY_TYPES.AGENT_REMOVED]: 'Agent Removed',
  [ACTIVITY_TYPES.AGENT_UPDATED]: 'Agent Updated',
  [ACTIVITY_TYPES.HOME_ADDED]: 'Home Added',
  [ACTIVITY_TYPES.HOME_REMOVED]: 'Home Removed',
  [ACTIVITY_TYPES.HOME_VIEWED]: 'Home Viewed',
  [ACTIVITY_TYPES.WALKTHROUGH_SCHEDULED]: 'Walkthrough Scheduled',
  [ACTIVITY_TYPES.WALKTHROUGH_COMPLETED]: 'Walkthrough Completed',
  [ACTIVITY_TYPES.MESSAGE_SENT]: 'Message Sent',
  [ACTIVITY_TYPES.MESSAGE_RECEIVED]: 'Message Received',
  [ACTIVITY_TYPES.BUSINESS_UPDATED]: 'Business Updated',
  [ACTIVITY_TYPES.OTHER]: 'Other'
};

/**
 * Shared user-facing strings
 */
export const ACCOUNT_BANNED_MESSAGE = 'Account has been banned. Contact support.';

/**
 * Shared CORS headers for API endpoints
 */
export const CORS_HEADERS = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
} as const;